export type CrossConfig = {
  mode?: 'preview' | 'live'; clearingApiUrl?: string; chainId?: number; chainName?: string;
  browserRpcUrl?: string; explorerUrl?: string; ponsUrl?: string; docsUrl?: string;
  walletConnectProjectId?: string;
  portfolioDeployment?: null | { chainId: number; settlement: `0x${string}`; credits: `0x${string}`; treasury: `0x${string}`; crossToken: `0x${string}`; tokens: { address: `0x${string}`; decimals: number }[] };
};
declare global { interface Window { CROSS_CONFIG?: CrossConfig } }
export const runtime = (): CrossConfig => window.CROSS_CONFIG ?? {};
export const isPreview = () => runtime().mode !== 'live';
